var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera-03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 5.2C1.33203 4.0799 1.33203 3.51984 1.55002 3.09202C1.74176 2.71569 2.04773 2.40973 2.42405 2.21799C2.85187 2 3.41193 2 4.53203 2H11.4654C12.5855 2 13.1455 2 13.5733 2.21799C13.9497 2.40973 14.2556 2.71569 14.4474 3.09202C14.6654 3.51984 14.6654 4.0799 14.6654 5.2V10.8C14.6654 11.9201 14.6654 12.4802 14.4474 12.908C14.2556 13.2843 13.9497 13.5903 13.5733 13.782C13.1455 14 12.5855 14 11.4654 14H4.53203C3.41193 14 2.85187 14 2.42405 13.782C2.04773 13.5903 1.74176 13.2843 1.55002 12.908C1.33203 12.4802 1.33203 11.9201 1.33203 10.8V5.2Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 10.6667C9.47146 10.6667 10.6654 9.47276 10.6654 8C10.6654 6.52724 9.47146 5.33333 7.9987 5.33333C6.52594 5.33333 5.33203 6.52724 5.33203 8C5.33203 9.47276 6.52594 10.6667 7.9987 10.6667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera03);
export default __webpack_public_path__ + "static/media/camera-03.7638529da52f0117750e3d790db29fd3.svg";
export { ForwardRef as ReactComponent };